module.exports = __webpack_public_path__ + "static/img/solutionDetailPic29.95b0561.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic29.png
// module id = 7ezM
// module chunks = 1